define('shared/util/providers/data/member',[
    '$',
    'shared/remote/member/get',
    'shared/util/registers/DataProvider',
    'shared/util/state',
    'shared/lib/RSVP',
    'shared/my/accessToken',
    'shared/page/apiVersion',
    'shared/page/runmode'
], function(
    $,
    getMember, 
    DataProvider,
    state,
    RSVP,
    accessToken,
    getAPIVersion,
    getRunMode
) {
    var done;

    function provideMemberInfo() {
        return getMember()
            .then(function(member){
                var provider = {
                    id:  'member',
                    type: 'page',
                    value: function(){
                        return member;
                    }
                };
                DataProvider.instance.register(provider);
            });
    }

    function provideMemberInfoIfLoggedIn(){
        var apiVersion;
        return getAPIVersion()
            .then(function(value){
                apiVersion = value;
                if (apiVersion == 'new-house') {
                    return accessToken.get()
                        .then(function(aToken){
                            if (aToken) {
                                return provideMemberInfo();
                            } else {
                                return null;
                            }
                        }, function(){
                            return null;
                        });
                } else {
                    return provideMemberInfo()
                        .then(null, function(){
                            return null;
                        });
                }
            });
    }

    return {
        provide: function(){
            if (done) {
                return done;
            }

            done = getRunMode()
                .then(function(wcmmode){
                    if (wcmmode !== 'publisher') {
                        return;
                    }

                    return provideMemberInfoIfLoggedIn();
                });

            return done;
        }
    };
});
